import React, { useRef, useState } from 'react';
import LogoDark from '../../../assets/logo-dark.svg';
import LogoWhite from '../../../assets/logo-white.svg';
import userApi from '../../../services/userApi';
import tokenService from '../../../utils/tokenService';
import Notification from '../../../components/notification/notification';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ThemeChanger from '../../../components/theme-changer/theme-changer';
import { TWInput, TWButton } from '../../../components/ui';
import Turnstile from '../../../components/turnstile/turnstile';

const NewPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [notf, setNotf] = useState({
    display: false,
    type: 'error',
    message: '',
  });
  const [state, setState] = useState({
    email: searchParams.get('email') || '',
    code: '',
    newpassword: '',
    newpasswordagain: '',
    loading: false,
  });
  const [errors, setErrors] = useState({ code: false, newpassword: false });
  const [isDarkMode, setIsDarkMode] = useState(
    tokenService.getTheme() === 'dark',
  );
  const [turnstileToken, setTurnstileToken] = useState(null);
  const turnstileRef = useRef(null);

  const onClickSendEmail = async () => {
    if (state.code === '' || state.newpassword === '') {
      setErrors({
        code: state.code === '',
        newpassword: state.newpassword === '',
      });
      return;
    }
    setErrors({ code: false, newpassword: false });
    setState((prev) => ({ ...prev, loading: true }));

    try {
      const res = await userApi.resetPassword(
        {
          email: state.email,
          code: state.code,
          newpassword: state.newpassword,
          newpasswordagain: state.newpassword,
        },
        turnstileToken
      );
      if (res.data) navigate('/');
    } catch (error) {
      turnstileRef.current?.reset();
      setNotf((prev) => ({ ...prev, message: error, display: true }));
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  return (
    <div className="relative flex h-screen flex-col justify-center bg-slate-50 py-12 px-6 dark:bg-slate-900 lg:px-8">
      <ThemeChanger
        position="right-5 top-5 absolute"
        onChange={setIsDarkMode}
      />
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          onClick={() => navigate('/')}
          className="mx-auto h-16 w-auto cursor-pointer"
          src={isDarkMode ? LogoWhite : LogoDark}
          alt="Thisway"
        />
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
          New Password
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="rounded-md border border-slate-200 bg-white px-6 py-8 shadow-sm dark:border-slate-700 dark:bg-slate-800 sm:px-10">
          <div className="space-y-5">
            <TWInput
              label="Code"
              type="number"
              required
              value={state.code}
              onChange={(e) =>
                setState((prev) => ({ ...prev, code: e.target.value }))
              }
              error={errors.code ? 'Enter your code' : undefined}
            />
            <TWInput
              label="New Password"
              type="password"
              required
              value={state.newpassword}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  newpassword: e.target.value,
                }))
              }
              error={errors.newpassword ? 'Enter your new password' : undefined}
            />
            <Turnstile ref={turnstileRef} onToken={setTurnstileToken} />
            <TWButton
              variant="primary"
              block
              size="lg"
              label="Reset Password"
              loading={state.loading}
              disabled={state.loading}
              onClick={onClickSendEmail}
            />
          </div>
        </div>
      </div>

      <Notification
        display={notf.display}
        type={notf.type}
        message={notf.message}
        onClose={() => setNotf((prev) => ({ ...prev, display: false }))}
      />
    </div>
  );
};

export default NewPassword;
